import type { FieldErrors } from 'react-hook-form'
import { toast } from 'sonner'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'
import { TOAST_IDS } from './config/toastIds'
import { toastPresets } from './config/toastPresets'

export const toastService = {
  thereIsAlreadyAnRequestInAnalysis(requestName: string) {
    toast.custom((t) => toastPresets.hasRequestInAnalysis(t, requestName), {
      id: TOAST_IDS.STUDENT.THERE_IS_ALREADY_AN_REQUEST_IN_ANALYSIS
    })
  },
  requestStepFailed(description?: string) {
    toast.custom((t) => toastPresets.requestStepFailed(t, description), {
      id: TOAST_IDS.COMMON.REQUEST_STEP_FAILED,
      duration: 8000
    })
  },
  blockedEnrollmentPeriod() {
    toast.custom((t) => toastPresets.blockedEnrollmentPeriod(t), {
      id: TOAST_IDS.COMMON.BLOCKED_ENROLLMENT_PERIOD,
      duration: 10000
    })
  },
  invalidFieldsInGrantReview(errors?: FieldErrors<MatchCoursesFormType>) {
    toast.custom((t) => toastPresets.invalidFieldsInGrantReview(t, errors), {
      id: TOAST_IDS.MANAGER.INVALID_FIELDS_IN_GRANT_REVIEW,
      duration: 10000
    })
  }
}
